// ==================== LANDING PAGE ====================
import { createClient } from '@supabase/supabase-js'
import { initI18n, setLanguage, updateTranslations, getCurrentLanguage } from './i18n.js'

// Initialize Supabase
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY
const supabase = createClient(supabaseUrl, supabaseKey)

// ==================== LANGUAGE SWITCHER ====================
function initLanguageSwitcher() {
  const langSelect = document.getElementById('languageSelect')
  if (!langSelect) return

  // Set current language
  langSelect.value = getCurrentLanguage()

  langSelect.addEventListener('change', (e) => {
    setLanguage(e.target.value)
  })

  // Update select when language changes from elsewhere
  window.addEventListener('languageChanged', (e) => {
    langSelect.value = e.detail.language
  })
}

// ==================== DEMO ADMIN AUTO-LOGIN ====================
const demoAdminBtn = document.getElementById('demoAdminBtn')

window.addEventListener('pageshow', (e) => {
  if (e.persisted && demoAdminBtn) {
    demoAdminBtn.disabled = false
    updateTranslations()
  }
})

demoAdminBtn?.addEventListener('click', async () => {
  const ctaEl = demoAdminBtn.querySelector('.demo-card-cta')
  const originalCta = ctaEl.textContent
  demoAdminBtn.disabled = true
  ctaEl.textContent = '...'

  try {
    const { data, error } = await supabase.functions.invoke('auth-login', {
      body: { username: 'demo', password: 'demo', type: 'admin' }
    })

    if (error) throw new Error(error.message)
    if (data?.error) throw new Error(data.error)

    sessionStorage.setItem('kixik_user', JSON.stringify(data.user))
    sessionStorage.setItem('kixik_session_token', data.sessionToken)
    window.location.href = '/equipment.html'

  } catch (err) {
    console.error('Demo login error:', err)
    demoAdminBtn.disabled = false
    ctaEl.textContent = originalCta
  }
})

// ==================== STICKY SECTION NAV ====================
function initSectionNav() {
  const sectionNav = document.getElementById('sectionNav')
  if (!sectionNav) return

  const hero = document.querySelector('.hero')
  const links = sectionNav.querySelectorAll('.section-nav-link')
  const sectionIds = ['features', 'how-it-works', 'use-cases', 'pricing', 'contact']

  const observer = new IntersectionObserver(
    ([entry]) => sectionNav.classList.toggle('visible', !entry.isIntersecting),
    { threshold: 0 }
  )
  if (hero) observer.observe(hero)

  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          links.forEach(l => l.classList.remove('active'))
          const active = sectionNav.querySelector(`[href="#${entry.target.id}"]`)
          if (active) active.classList.add('active')
        }
      })
    },
    { rootMargin: '-20% 0px -70% 0px' }
  )

  sectionIds.forEach(id => {
    const el = document.getElementById(id)
    if (el) sectionObserver.observe(el)
  })
}

// ==================== INITIALIZATION ====================
document.addEventListener('DOMContentLoaded', async () => {
  await initI18n()
  updateTranslations()
  initLanguageSwitcher()
  initSectionNav()
  if (typeof lucide !== 'undefined') lucide.createIcons()
})

// Contact form handler
const contactForm = document.getElementById('contactForm')
const contactBtnText = document.getElementById('contactBtnText')
const contactFormError = document.getElementById('contactFormError')
const contactFormSuccess = document.getElementById('contactFormSuccess')

contactForm?.addEventListener('submit', async (e) => {
  e.preventDefault()
  
  // Disable form
  contactBtnText.textContent = 'Sending...'
  contactForm.querySelector('button').disabled = true
  contactFormError.classList.remove('show')
  contactFormSuccess.style.display = 'none'
  
  // Get form data
  const formData = new FormData(contactForm)
  const data = {
    name: formData.get('name'),
    company: formData.get('company') || null,
    email: formData.get('email'),
    phone: formData.get('phone') || null,
    message: formData.get('message') || null,
    equipmentEstimate: formData.get('equipmentEstimate')
  }
  console.log('Sending data:', data) 
  try {
    // Используем существующий supabase клиент вместо fetch
    const { data: responseData, error } = await supabase.functions.invoke('send-contact-email', {
      body: data
    })
    
    if (error) throw error
    
    // Success
    contactForm.reset()
    contactFormSuccess.style.display = 'block'
    setTimeout(() => {
      contactFormSuccess.style.display = 'none'
    }, 5000)
    
  } catch (error) {
    contactFormError.textContent = error.message
    contactFormError.classList.add('show')
  } finally {
    contactBtnText.textContent = 'Send message'
    contactForm.querySelector('button').disabled = false
  }
})
